module.exports = __webpack_public_path__ + "img/odf.33229caa.png";